<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-dialog-class"
  >
    <section class="flex flex-col items-center justify-center">
      <send-icon size="lg:h-12 lg:w-12 h-10 w-10" :primaryColor="true" />
      <h4 class="text-center lg:text-xl text-fg-default font-semibold mt-6">
        Start Wire Transfer
      </h4>
      <p
        style="word-break: normal"
        class="text-xs lg:text-sm text-fg-muted font-light text-center my-6 italic"
      >
        Note: Deposit may take 2-4 days to clear. <br />
        And this transfer would remain pending until deposit is received.
      </p>
      <el-button
        class="lg:px-8 px-4 lg:py-5 py-4 rounded-lg shadow-sm bg-primary text-white w-full"
        @click="startTransferHandler"
        >Start Transfer</el-button
      >
    </section>
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'StartWireTransfer',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SendIcon: () => import('@/assets/v2/icons/SendIcon')
  },
  data () {
    return {
      breakpoints,
      transferReason: '',
      color: this.$primaryColor
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    startTransferHandler () {
      this.$emit('startTransfer')
    }
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  animation: slide-fade 0.3s ease forwards;
}
.slide-fade-leave-active {
  animation: slide-fade 0.3s ease forwards alternate-reverse;
}

@media screen and (max-width: 768px) {
  >>> .el-radio__label {
    font-size: 12px;
  }
}
>>> .el-dialog {
  border-radius: 0.5rem !important;
}
>>> .el-radio__inner {
  height: 1.2rem;
  width: 1.2rem;
  border: 2px solid #bdbdbd;
}
@media screen and (min-width: 1280px) {
  >>> .custom-dialog-class {
    margin-left: 41vw;
  }
}
</style>
